import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router/index.js';
import './assets/css/style.css';
import axios from 'axios';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

axios.defaults.timeout = 1200000;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && error.response.status === 401) {
        // 응답값의 타입이 ArrayBuffer인 경우 JSON으로 변환
        if (error.response.data instanceof ArrayBuffer) {
          const decoder = new TextDecoder('utf-8');
          const text = decoder.decode(error.response.data);
          const json = JSON.parse(text)

          error.response.data = json;
        }

        alert(error.response.data.msg);
        router.push({ name: '/Login' });
      }
      console.error(error);
      return Promise.reject(error);
    }
);

const app = createApp(App)
app.component('VueDatePicker', VueDatePicker)
app.config.globalProperties.$axios = axios
app.use(router)
app.mount('#app')